import { render, staticRenderFns } from "./Sedan.vue?vue&type=template&id=0296a0d1&"
import script from "./Sedan.vue?vue&type=script&lang=ts&"
export * from "./Sedan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports